import { getDefaultState } from '@/store/modules/authUser/'

const mutations = {
    SET_AUTH(state, isLogged) {
        state.userIsLoggedIn = isLogged
    },

    ADD_JOB_TO_FAVORITES(state, code) {
        state.jobsBasket.add(code)
        state.jobsBasket = new Set(state.jobsBasket)
    },

    ADD_JOBS_TO_FAVORITES(state, allcodes) {
        Object.assign(state, getDefaultState())
        allcodes = allcodes.filter(code => Number(code) > 0)
        state.jobsBasket = new Set(allcodes)
    },

    REMOVE_JOB_FROM_FAVORITES(state, code) {
        state.jobsBasket.delete(code)
        state.jobsBasket = new Set(state.jobsBasket)
    },
    CLEAR_JOB_BASKET(state) {
        Object.assign(state, getDefaultState())
    },

    ADD_STEP_1_CATEGORY(state, { cat }) {
        state.smartAgent.firstStepCategory.cat = cat
    },

    ADD_STEP_1_EMAIL(state, email) {
        state.smartAgent.firstStepCategory.email = email
    },
    SET_SMART_AGENT_STEP(state, step) {
        state.smartAgent.currentStep = step
    }
}

export default mutations